import { render } from "./InformationIcon.vue?vue&type=template&id=61b6b3ce&ts=true"
import script from "./InformationIcon.vue?vue&type=script&lang=ts"
export * from "./InformationIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__